import React from 'react';
import { Paper, makeStyles } from '@material-ui/core';
import { styles } from 'components/Table/Table.styles';
import TableToolbar from 'components/TableToolbar';
import Table from 'components/Table/Table';
import ConnectedTableFilters from 'components/Table/ConnectedTableFilters';
import { TableConfigEntry } from 'utils/tableConfig';
import { getReadableDate } from 'utils/utils';
import { useTagTermRelationTypes } from 'novaApi/hooks/tag_term_relation_type';
import ConnectedButton from 'components/Button/ConnectedButton';
import InternalLink from 'components/Link/InternalLink';

const useStyles = makeStyles(styles);

const tableConfig = (): TableConfigEntry<Nl.Api.TagTermRelationType> => ({
  columnData: [
    {
      id: 'name',
      label: 'Name',
      isSortable: true,
      render: ({ uuid, name }) => (
        <InternalLink
          color='inherit'
          to={{ type: 'route/TAG_TERM_RELATION_TYPES_EDIT', payload: { uuid } }}
        >
          {name}
        </InternalLink>
      ),
    },
    {
      id: 'description',
      label: 'Description',
      isSortable: true,
      render: ({ description }) => description,
    },
    {
      id: 'created_at',
      label: 'Created',
      isSortable: true,
      render: ({ created_at }) => getReadableDate(created_at) || '-',
    },
    {
      id: 'updated_at',
      label: 'Last Modified',
      isSortable: true,
      render: ({ updated_at }) => getReadableDate(updated_at) || '-',
    },
  ],
});

export default function TagTermRelationTypesPage() {
  const classes = useStyles({});
  const { data, isLoaded } = useTagTermRelationTypes();

  return (
    <Paper elevation={1} className={classes.root}>
      <TableToolbar
        title='Tag-Term Relation Types'
        search={
          <ConnectedTableFilters
            filters={[
              {
                type: 'search',
                size: 6,
                label: 'Search by name',
                queryFilterKey: 'name',
                e2e: 'tagTermRelationType-search-name',
              },
            ]}
          />
        }
        actions={
          <ConnectedButton
            icon='add'
            fab
            route='route/TAG_TERM_RELATION_TYPES_CREATE'
            label='Create new Tag-Term Relation Type'
            permission='CAN_CREATE_TAG_TERM_RELATION_TYPE'
          />
        }
      />
      <Table
        config={tableConfig()}
        data={data?.tag_term_relation_types}
        isLoaded={isLoaded}
        paginationData={data}
      />
    </Paper>
  );
}
